<template>
  <div class="sports-page">
    <v-layout  class="page-layout">
      <v-flex class="main-column" :style="{paddingTop: headerHeight + 'px'}" ref="maincolumn">
        <resize-observer @notify="mainColumnResize" />
         <div class="staticcontent">
          <div class="static-content accpage">
            <static-content :staticcontentpath="'/static/static-content/'" :method="'html'"></static-content>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
  import store from '@/store'
  import Screen from '@/components/mixins/Screen'

  import HeaderPart from '@/components/layout/parts/HeaderPart'
  import StaticContent from '@/components/common/StaticContent'

  export default {
    name: 'AboutUsPage',

    mixins: [
      Screen
    ],

    components: {
      HeaderPart,
      StaticContent
    },

    data () {
      return {
        right: true,
        iframeHeight: '400px'
      }
    },

    computed: {
      headerHeight () {
        return store.getters['screenState/getHeaderHeight']
      },
      mainColumnWidth () {
        return store.getters['screenState/getMainColumnWidth']
      },
      infoPageName () {
        return this.$route.params.infopagename
      }
    },
    mounted () {
      this.mainColumnResize()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    methods: {
      mainColumnResize () {
        var mainColumn = this.$refs.maincolumn
        if (mainColumn) {
          store.commit('screenState/setMainColumnWidth', mainColumn.offsetWidth)
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import "~@/css/config"

iframe
  width 100%
  height 100%
  // min-height 400px
.static-content
  .ca
    padding 5px 0
    .pd-icon
      width 30px
      display inline-flex
      align-items center
      justify-content center
  .ca_email .pd-icon
    font-size 15px
.staticcontent
  display flex
.static_content_links
  width 250px
  >>>.sc_links
    .navigation
      .navigation-item
        line-height 38px
        font-size 14px
        padding 0 16px
        a
          color #fff !important	
          &:hover
            font-weight 600
        .router-link-exact-active.router-link-active
          font-weight 600
  .sc_header
    color #fff
    font-size 18px
    font-weight 600
    padding 0 16px
    line-height 48px
    background rgba(255,255,255,0.3)
    border-radius 5px
    margin-bottom 10px


</style>



// WEBPACK FOOTER //
// src/components/pages/StaticContentPage.vue